<template>
    <div
        class="Alert"
        :class="{
            [`Alert--${type}`]: true,
            'Alert--rounded': rounded,
        }"
    >
        <h4 v-if="$slots.title || title">
            <slot name="title">
                {{ title }}
            </slot>
        </h4>
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component } from 'vue-property-decorator';

    import AlertBase from './AlertBase';

    @Component
    export default class Alert extends AlertBase {}
</script>
